import { getInit } from "./InitCarFilterHeader";
import CarFilterHeader from "./components/toyota/CarFilterHeader";

export const init = getInit(CarFilterHeader);
